import React from 'react';
import SystemAPI from 'fw/system/API'
import { Col, Row } from 'react-bootstrap';
import { Label, DownloadFileLink } from 'fw/components';

export const downloadFile = (storageToken, fileName) => {
	new SystemAPI().download({
		storageToken: storageToken,
		fileName: fileName
	});
};

export const renderPhones = (phoneList) => {
	return(
		phoneList.map((phone, i) => (
			<div key={`phone_${i}`}>
				<a href={`tel:${phone.countryCode}${phone.number}`}>
					{phone.phoneTypeCode}: {phone.countryCode} {phone.number} {phone.extension ? ` #${phone.extension}` : null}
				</a>
				<br />
			</div>))
	);
}

export const renderCertificationFile = (title, storageToken, fileName) => {
	return(
		<React.Fragment>
			<Label>{title}</Label>&nbsp;
			<DownloadFileLink
				storageToken={storageToken}
				fileName={fileName}
				buttonName={fileName}
				buttonStyle="link"
				wrapFileNameLength={40}
			/>
		</React.Fragment>
	);
}

export const renderOtherCertifications = (form) => {
	const otherCertifications = form.otherCertifications;

	return(
		otherCertifications.map((cert, i) => (
			<div key={`other_cert_${i}`}>
				<li>
					{renderCertificationFile("", cert.storageToken, cert.fileName)}
				</li>
			</div>))
	);
}

export const renderCertifications = (form) => {
	return(
		<React.Fragment>
			{form.nmsdcStorageToken ?
				<Row>
					<Col md={12}>
						{renderCertificationFile("NMSDC Certification:", form.nmsdcStorageToken, form.nmsdcFileName)}
					</Col>
				</Row>
			: null}
			{form.wbencStorageToken ?
				<Row>
					<Col md={12}>
						{renderCertificationFile("WBENC Certification:", form.wbencStorageToken, form.wbencFileName)}
					</Col>
				</Row>
			: null}
			{form.nglccStorageToken ?
				<Row>
					<Col md={12}>
						{renderCertificationFile("NGLCC Certification:", form.nglccStorageToken, form.nglccFileName)}
					</Col>
				</Row>
			: null}
			{form.otherCertifications && form.otherCertifications.length > 0 ?
				<Row>
					<Col md={12}>
						<Label>Other Certifications:</Label>
						<ul>
							{renderOtherCertifications(form)}
						</ul>
					</Col>
				</Row>
			: null}
		</React.Fragment>
	);
}


// WEBPACK FOOTER //
// ./src/areas/shared/helpers/CompanyInfoTabHelpers.js